import * as React from 'react';
import * as moment from 'moment';
import { Moment } from 'moment';
import { RendererComponentProps, ContextObserver } from '../../../webana';
import { DatePicker, List, Select, Icon, Card, Button } from 'antd';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Subscriber } from 'react-broadcast';
import { evaluate } from '../../../utils/StringUtils';
import { OptionProps } from 'antd/lib/select';

interface EmployeeDividerConfig {
  content?: string;
  style?: React.CSSProperties;
  className?: string;
}

interface EmployeeDividerState {
  employeesAssignments: { [key: string]: string[] };
  employeesUnsaved: { [key: string]: { employees: string[]; crew: any } };
  employeesSaving: { [key: string]: boolean };
}

@observer
export class EmployeeDividerComponent extends React.Component<
  RendererComponentProps<EmployeeDividerConfig> & ContextObserver<any>,
  EmployeeDividerState
> {
  state = {
    employeesAssignments: {},
    employeesUnsaved: {},
    employeesSaving: {},
    hint: {
      text: "txt",
       show: 0,
       x: 0,
       y: 0,
    }
  };

  getUnavailableEmployees(crewId: string): any[] {
    const crewResource = this.props.context.resources.vehicleCrew;
    const vehicleCrew: any[] | undefined =
      crewResource.data && crewResource.data.items;

    if (!vehicleCrew) {
      return [];
    }

    let employeesIds: string[] = [];
    for (let crew of vehicleCrew) {
      if (
        crew.id !== crewId &&
        crew.nsVoXMLZamLst &&
        !this.state.employeesUnsaved[crew.id]
      ) {
        employeesIds = [...crew.nsVoXMLZamLst, ...employeesIds];
      }
    }

    for (let key of Object.keys(this.state.employeesUnsaved)) {
      const item = this.state.employeesUnsaved[key];
      if (item.crew.id !== crewId && item.employees) {
        employeesIds = [...item.employees, ...employeesIds];
      }
    }

    return employeesIds;
  }

  async saveAssignment(crew: any, employees: string[]) {
    const { context } = this.props;
    const crewResource = context.resources.vehicleCrew;
    let employeesSaving = Object.assign({}, this.state.employeesSaving) as {[key: string]: boolean;};
    employeesSaving[crew.id] = true;
    this.setState({ employeesSaving });

    const rt = (this.props as any).router;

    await crewResource.custom("set", crew.id, {
      id: crew.id,
      nsVoXMLRVLst: crew.nsVoXMLRVLst,
      nsVoXMLZamLst: employees,
    }, {switches: {dKalDatum: (rt.location.state || {}).employeeDividerDate || moment().format('YYYY-MM-DD')}});

    employeesSaving[crew.id] = false;
    this.setState({ employeesSaving });
  }

  changeAssignees(crew: any, employees: string[]) {
    let employeesUnsaved = this.state.employeesUnsaved;
    let employeesAssignments = this.state.employeesAssignments;
    employeesUnsaved[crew.id] = { employees, crew };
    employeesAssignments[crew.id] = employees;
    this.setState({ employeesUnsaved, employeesAssignments });
  }

  hasChanges(): boolean {
    return Object.keys(this.state.employeesUnsaved).length > 0;
  }

  save = async () => {
    const clear = (id: string) => {
      let empsUnsaved = this.state.employeesUnsaved;
      delete empsUnsaved[id];
      this.setState({ employeesUnsaved: empsUnsaved });
    };

    let empsUnsavedCp = Object.assign({}, this.state.employeesUnsaved);
    
    for (let key of Object.keys(empsUnsavedCp)) {
      const item = empsUnsavedCp[key];
      await this.saveAssignment(item.crew, item.employees);
      clear(item.crew.id);
    }

    (this.props as any).resources.vehicleCrew.reload();
  };

  reset() {
    this.setState({
      employeesAssignments: {},
      employeesSaving: {},
      employeesUnsaved: {}
    });
  }

  filterOption = (input: string, option: React.ReactElement<OptionProps>) => {
    let child = (option.props.children as any);
    
    if (!(child && child.props)) {
      return false;
    }
    
    child = child.props.children[0];

    if (typeof child === 'string') {
      input = input.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

      return (
        child.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(input) !== -1
      );
    }
    return false;
  };

  showHint = (e: any, txt: string, show = true) => {
    const hn = this.state.hint;
    const nte = e.nativeEvent;
    const antSel = nte.target.closest(".ant-select-selection__choice")
    //console.log("NTE", nte);

    if(antSel) {
      antSel.removeAttribute("title");
      console.log("ANTSEL", antSel);
    }

    if(show && txt) {
        hn.x = nte.pageX + 8;
        hn.y = nte.pageY + 8;
        hn.text = txt;
    }
    hn.show = show && txt ? 1 : 0;

    this.setState(s=> s);
  }

  render() {
    (window as any).tt = this;

    const { context } = this.props;
    const crewResource = context.resources.vehicleCrew;
    let vehicleCrew: any[] = toJS(crewResource.data && crewResource.data.items) || [];
    const emp = context.resources.employees;
    const rt = context.router.location;
    const employees: any[] = (emp.data && emp.data.items) || [];
    const todayButtonVisible = moment(rt && rt.state && rt.employeeDividerDate).format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD');
    const saveButtonDisabled = !this.hasChanges();

    const s = this.state;

    if(crewResource) {
      const crt = crewResource.times;
      const last = crt[crt.length-1];
      const find = last ? crt.find((f: any) => f.start < last.start && f.end > last.end) : null;

      if(find && last) {
        //pokud se najde takovy zaznam, co zacal driv, ale skoncil po poslednim, zahodi se
        vehicleCrew = last.res.items || [];
      }

      // řazení
      //vehicleCrew = vehicleCrew.sort((a, b) => (a.nsVuzNazev > b.nsVuzNazev as any));
      vehicleCrew = vehicleCrew.sort((a, b) => a.nsVuzNazev.localeCompare(b.nsVuzNazev, 'cs-CZ', {sensitivity: 'variant', caseFirst: 'upper'})); 
    }

    return (
      <>
        <div className="rozdeleni-hint" style={{ left: s.hint.x, top: s.hint.y, opacity: s.hint.show}}>{this.state.hint.text}</div>
        <Card
          title={[
            <Button
              className="prev-button"
              type="primary"
              key="prev-button"
              onClick={() => evaluate('redirect(".",{employeeDividerDate: moment(rls?.employeeDividerDate).add(-1, "days").format("YYYY-MM-DD")})', context)}
            >
              ➽
            </Button>,
            " ",
            <DatePicker
              key="date-picker"
              allowClear={false}
              value={evaluate('moment(rls?.employeeDividerDate)', context)}
              onChange={(date: Moment, value: string) => {
                this.reset();
                evaluate('redirect(\'.\',{employeeDividerDate:value})', {value, ...context});
              }}
            />,
            " ",
            <Button
              className="next-button"
              type="primary"
              key="next-button"
              onClick={() => {
                this.reset();
                evaluate('redirect(".",{employeeDividerDate: moment(rls?.employeeDividerDate).add(1, "days").format("YYYY-MM-DD")})', context);
              }}
            >
              ➽
            </Button>,   
            todayButtonVisible ? (
              <Button
                key="set-today-button"
                type="primary"
                onClick={() => {
                  this.reset();
                  evaluate('redirect(".",{employeeDividerDate:undefined})', context);
                }}
              >
                Dnes
              </Button>
            ) : undefined,       
          ]}
          extra={<Button type="primary" disabled={saveButtonDisabled} onClick={this.save}>Uložit</Button>}
        >
          <List
            dataSource={vehicleCrew}
            loading={crewResource.loading}
            renderItem={(crew: any) => {
              const unavailableEmployees = this.getUnavailableEmployees(crew.id);
              const isSaving = this.state.employeesSaving[crew.id] || false;
              const employeeIds = this.state.employeesAssignments[crew.id] || crew.nsVoXMLZamLst || [];

              let hlaska = "";
              if(crew.bVoJeMissZam && crew.bVoJeKolizeZam) {
                hlaska = "Existuje neúplná i kolizní osádka!";
              }
              else if(crew.bVoJeMissZam) {
                hlaska = "Existuje neúplná osádka!";
              }
              else if(crew.bVoJeKolizeZam) {
                hlaska = "Existuje kolize!";
              }

              return (
                <List.Item>
                  <List.Item.Meta 
                    className={(crew.bVoJeKolizeZam ? "kolize " : "bezKl ") + (crew.bVoJeMissZam ? "vysvitit" : "bezVs")} 
                    title={
                      <span 
                        onMouseOver={(e: any) => this.showHint(e, hlaska, crew.bVoJeKolizeZam || crew.bVoJeMissZam)}
                        onMouseOut={(e: any) => this.showHint(e, crew.nsVuzNazev, false)}
                      >
                        {crew.nsVuzNazev}
                      </span>
                    } 
                  />
                  <Select
                    onChange={(values: string[]) => this.changeAssignees(crew, values)}
                    disabled={isSaving}
                    mode="tags"
                    filterOption={this.filterOption}
                    value={employeeIds}
                    style={{ width: '100%' }}
                    onFocus={() => console.log("mo")}
                  >
                    {employees.map(em => {
                      const kz1 = (crew.nsVoXMLKolizeZamLst || []).find((f: any) => f.iZI === +em.id);
                      const kz2 = (crew.nsVoXMLMissZamLst || []).find((f: any) => f.iZI === +em.id);
                      let hintTxt = "";
                      let dt = new Date().getTime();

                      if(kz1 || kz2) {
                        hintTxt = [(kz1 || {}).nsDP || "", (kz2 || {}).nsMP || ""].filter(f => !!f).join(", ");
                      }

                      //console.log("LIST", toJS(crew.nsVoXMLMissZamLst) || [], em.id);

                      const grey = employeeIds.indexOf(em.id) === -1 && unavailableEmployees.indexOf(em.id) !== -1;

                      return (em.bZamAktivni || (employeeIds.indexOf(em.id) >= 0)) ? (
                        <Select.Option
                          disabled={false}
                          key={em.id + dt}
                          value={em.id}
                          title={em.nsZamNazev}
                        >
                          <span 
                            onMouseOver={(e: any) => this.showHint(e, hintTxt, true)}
                            onMouseOut={(e: any) => this.showHint(e, hintTxt, false)}
                            className={
                              (em.nsZamIndi ? 'zamIndispozice ' : 'zam ') + 
                              (grey ? 'seda ' : 'cerna ') +
                              (kz1 ? 'kz1 ' : 'nkz1 ') +
                              (kz2 ? 'kz2 ' : 'nkz2 ')              
                            }
                          >
                            {em.nsZamNazev} 

                            {em.nsZamIndi ? 
                              <span style={{ fontSize: "11px", fontWeight: "normal", marginLeft: "5px" }}>({em.nsZamIndi})</span>
                            : false
                            }
                          </span>
                        </Select.Option>
                      ) : [];
                    })}
                  </Select>

                  <Icon
                    style={{ marginTop: '5px', fontSize: '20px' }}
                    type={isSaving ? 'loading' : this.state.employeesUnsaved[crew.id] ? 'save' : 'check'}
                  />
                </List.Item>
              );
            }}
          />
        </Card>
      </>
    );
  }
}

export class EmployeeDivider extends React.Component<RendererComponentProps<EmployeeDividerConfig>> {
  render() {
    return (
      <Subscriber channel="context">
        {ctx => <EmployeeDividerComponent {...this.props} context={ctx} />}
      </Subscriber>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/sezako/components/EmployeeDivider.tsx